import { useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";

export default function PlanBadge({ plan }) {
  const nav = useNavigate();
  if (!plan) return null;

  if (plan.plan === "free") {
    const usage = `${plan.trips_count}/${plan.trip_limit} trip${plan.trip_limit === 1 ? "" : "s"} used`;
    return (
      <div
        className="mt-3 inline-flex items-center gap-2 px-3 py-1 rounded-full bg-muted text-xs text-stone-600"
        data-testid="plan-badge"
      >
        <span className="uppercase tracking-widest text-stone-500">Free</span>
        <span>·</span>
        <span>{usage}</span>
        <button
          onClick={() => nav("/pricing")}
          className="ml-1 text-primary font-medium hover:underline flex items-center gap-1"
          data-testid="upgrade-inline-btn"
        >
          <Sparkles className="w-3 h-3" /> Upgrade
        </button>
      </div>
    );
  }

  if (plan.plan === "pro" || plan.plan === "family") {
    return (
      <div
        className="mt-3 inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-xs text-primary"
        data-testid="plan-badge"
      >
        <Sparkles className="w-3 h-3" /> {plan.plan === "family" ? "Family" : "Pro"} · unlimited
      </div>
    );
  }

  return null;
}
